module.exports = __webpack_public_path__ + "img/CovidSector_Infographics_13.c0a8c804.png";